module.exports = __webpack_public_path__ + "img/mockup-creator-profile.0ed21925.png";